import { useMemo } from "react";
import TEMPLATES from "./templates";
import { ProgramContextProvider, useProgramContext } from "./ProgramContext";

const InlineProgramForm = ({ form, programTemplate, size = "lg", showHeaderFields = true }) => {
  const { engine } = useProgramContext();
  const TemplateComponent = useMemo(() => {
    const template = TEMPLATES.find((t) => t.id === programTemplate && t.engine === engine);
    if (template?.defaultValues) {
      form.reset(template.defaultValues);
    }

    return template?.FormComponent || null;

    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [programTemplate]);

  return (
    TemplateComponent && (
      <ProgramContextProvider engine={"pricing"} size={size} showHeaderFields={showHeaderFields}>
        <TemplateComponent {...form} />
      </ProgramContextProvider>
    )
  );
};

export default InlineProgramForm;
